import { Component } from "@angular/core";

@Component({
  selector: "app-enterprise-content",
  templateUrl: "enterprise-content.component.html",
})
export class EnterpriseContentComponent {}
